import projectService from '../../services/project';
import templateService from '../../services/template';
import Vue from 'vue';
// import Vue from 'vue'

const state = {
    all: [],
    error: false,
    loading: false,
    project: {
        id: 0,
        name: '',
        code: '',
        scenes: [],
    },
    previewGuestIndex: null,
    activeScene: null,
    activeVersion: null,
    personalizedValue: '',
    preview: false
}

const getters = {
    error: (state) => state.error,
    loading: (state) => state.loading,
    project: (state) => state.project,
    activeScene: (state) => state.activeScene,
    personalizedValue: (state) => state.personalizedValue,
    activeVersion: (state) => state.activeVersion,
    scene: (state) => state.project.scenes.length && state.project.scenes[state.activeScene],
    version: (state, getters) => getters.scene && getters.scene.versions[state.activeVersion],
    previewGuestIndex: (state) => state.previewGuestIndex,
    previewGuest: (state, getters) => getters.scene && getters.scene.guests[state.previewGuestIndex],
    isPreview: (getters) => getters.preview,
}

const actions = {
    getTemplates({ commit }) {
        commit('setLoading');

        return templateService.getAll()
            .then((response) => {
                commit('setLoading', false);

                return response;
            })
            .catch((error) => {
                commit('setLoading', false);
                commit('setError', error);
            })
    },
    getProjects({ commit }) {
        commit('setLoading');

        return projectService.getAll()
            .then((response) => {
                commit('setLoading', false);

                return response;
            })
            .catch((error) => {
                commit('setLoading', false);
                commit('setError', error);
            })
    },
    getOneTemplate({ commit, dispatch }, templateCode) {
        commit('setLoading');

        return templateService.getOneByCode(templateCode)
            .then((response) => {
                commit('setLoading', false);
                commit('setProject', response.data);
                dispatch('setActiveSceneVersion', { scene: 0, version: 0 });

                return response
            })
            .catch((error) => {
                commit('setLoading', false);
                commit('setError', error);
            })
    },
    getOneProject({ commit, dispatch }, projectId) {
        commit('setLoading');

        return projectService.getOneByHash(projectId)
            .then((response) => {
                commit('setLoading', false);
                commit('setProject', response.data);
                dispatch('setActiveSceneVersion', { scene: 0, version: 0 });

                return response
            })
            .catch((error) => {
                commit('setLoading', false);
                commit('setError', error);
            })
    },
    setTemplate({ commit }, data) {
        commit('setLoading');

        return templateService.setTemplate(data)
            .then(({ id }) => {
                commit('setLoading', false);
                commit('updateProject', { id });
            })
            .catch((error) => {
                commit('setLoading', false);
                commit('setError', error);
            })
    },
    setProject({ commit }, data) {
        commit('setLoading');

        return projectService.setProject(data)
            .then((response) => {
                commit('setLoading', false);

                if (response.success) {
                    commit('updateProject', response.project);
                }

                return response;
            })
            .catch((error) => {
                commit('setLoading', false);
                commit('setError', error);
            })
    },
    setProjectStatus({ commit }, data) {
        commit('setLoading');

        return projectService.setProjectStatus(data)
            .then((response) => {
                commit('setLoading', false);

                return response
            })
            .catch((error) => {
                commit('setLoading', false);
                commit('setError', error);
            })
    },
    deleteTemplate({ commit }, templateId) {
        commit('setLoading');

        return templateService.deleteTemplate(templateId)
            .then(() => commit('setLoading', false))
            .catch((error) => {
                commit('setLoading', false);
                commit('setError', error);
            })
    },
    deleteProject({ commit }, projectId) {
        commit('setLoading');

        return projectService.deleteProject(projectId)
            .then(() => commit('setLoading', false))
            .catch((error) => {
                commit('setLoading', false);
                commit('setError', error);
            })
    },
    setActiveSceneVersion({ commit }, params) {
        commit('setActiveSceneVersion', params)
    },
    newSceneVersion({ commit, dispatch, getters }, scene) {
        commit('newSceneVersion', scene)

        const newSceneIndex = getters.project.scenes.length - 1

        dispatch('setSceneGuests', { scene: newSceneIndex, guests: [] })
        dispatch('setActiveSceneVersion', { scene: newSceneIndex, version: 0 })
    },
    removeScene({ commit }, index) {
        commit('removeScene', index)
    },
    newScene({ commit, dispatch, state }, scene) {
        commit('newScene', scene)
        console.log(scene);

        dispatch('setActiveSceneVersion', { 
            scene: state.project.scenes.length - 1,
            version: 0
        })
    },
    setNote({ commit }, data) {
        commit('setNote', data)
    },
    setScene({ commit, getters }, scene) {
        commit('setScene', { scene, activeScene: getters.activeScene })
    },
    setSceneQuantity({ commit }, data) {
        commit('setSceneQuantity', data)
    },
    setSceneGuests({ commit }, data) {
        commit('setSceneGuests', data)
    },
    removeSceneGuest({ commit }, data) {
        commit('removeSceneGuest', data)
    },
    setPreviewGuest({ commit }, guest) {
        commit('setPreviewGuest', guest)
    },
    setPreview({ commit }, status) {
        commit('setPreview', status)
    },
    setPreviewGuestIndex({ commit, dispatch, getters }, guestIndex) {

        if (!getters.isPreview) {
            dispatch('setActiveSceneVersion', {
                scene: getters.activeScene,
                version: getters.scene.versions.findIndex((version) => version.personalizedField),
            });
        }

        commit('setPreviewGuestIndex', guestIndex)
        commit('setPreview', guestIndex !== null)
    },
    setGuestPosition({ commit, getters }, cords) {
        if (getters.previewGuestIndex !== null) {

            cords.x -= getters.scene.guestCords.x
            cords.y -= getters.scene.guestCords.y

            commit('setPreviewGuest', cords)
        } else {
            commit('setGuestPosition', cords)
        }
    },
    setSceneName({ commit }, data) {
        commit('setSceneName', data)
    },
    setPresonalizedValue({ commit }, value) {
        commit('setPresonalizedValue', value)
    },
    setActiveInvitationContent({ commit, getters }, content) {
        console.log('setActiveInvitationCOntent is preveiw', getters.isPreview)
        if (getters.isPreview) {
            return
        }
        
        console.log('set setActiveInvitationContent ')
        commit('setActiveInvitationContent', content)
    },
}

const mutations = {
    setNote(state, data) {
        Vue.set(state.project.scenes[data.scene], 'note', data.note)
    },
    setPresonalizedValue(state, value) {
        state.personalizedValue = value
    },
    setActiveSceneVersion(state, { scene, version }) {
        state.activeScene = scene
        state.activeVersion = version
    },
    setScene(state, { scene, activeScene}) {
        Vue.set(state.project.scenes, activeScene, scene)
    },
    setSceneName(state, { scene, name }) {
        state.project.scenes[scene].name = name
    },
    setSceneGuests(state, { scene, guests }) {
        state.project.scenes[scene].guests = guests
    },
    removeSceneGuest(state, { scene, guestIndex }) {
        state.project.scenes[scene].guest = state.project.scenes[scene].guests.splice(guestIndex, 1)
    },
    setPreview(state, status) {
        state.preview = status
    },
    setPreviewGuest(state, guest) {
        const guests = state.project.scenes[state.activeScene].guests
        Vue.set(guests, state.previewGuestIndex, Object.assign({}, guests[state.previewGuestIndex], guest))
    },
    setGuestPosition(state, cords) {
        Vue.set(state.project.scenes[state.activeScene], 'guestCords', cords)
    },
    setPreviewGuestIndex(state, guestIndex) {
        state.previewGuestIndex = guestIndex
    },
    setSceneQuantity(state, { scene, value }) {
        state.project.scenes[scene].emptyGuest = value
    },
    setActiveInvitationContent(state, content) {
        console.log('state.activeScene', state.activeScene)
        console.log('state.activeVersion', state.activeVersion)
        state.project.scenes[state.activeScene].versions[state.activeVersion].content = content
    },
    newSceneVersion(state, scene) {
        state.project.scenes.push(JSON.parse(JSON.stringify(state.project.scenes[scene])));
    },
    newScene(state, scene) {
        if (! state.project.scenes) {
            state.project.scenes = [];
        }

        state.project.scenes.push(scene);
    },
    removeScene(state, index) {
        state.project.scenes.splice(index, 1);
    },
    setLoading(state, loading = true) {
        state.loading = loading;
    },
    setError(state, error) {
        state.error = error;
    },
    setProject(state, project) {
        Vue.set(state, 'project', project);
        // state.project = project;
    },
    updateProject(state, data) {
        Vue.set(state, 'project', Object.assign({}, state.project, data));
        // Object.assign(state.project, data); 
    },
    deleteRequest(state) {
        state.project = { loading: true }
    },
    getAllSuccess(state, projects) {
        state.all = projects;
    },
    getOneSuccess(state, data) {
        state.project = data;
    },
    deleteSuccess(state, response) {
        state.remove = response;
    },
    deleteFailure(state, error) {
        state.remove = { error }
    },
    // deleteRequest(state, id) {
    //     // add 'deleting:true' property to user being deleted
    //     state.all.items = state.all.items.map(user =>
    //         user.id === id
    //             ? { ...user, deleting: true }
    //             : user
    //     )
    // },
    // deleteSuccess(state, id) {
    //     // remove deleted user from state
    //     state.all.items = state.all.items.filter(user => user.id !== id)
    // },
    // deleteFailure(state, { id, error }) {
    //     // remove 'deleting:true' property and add 'deleteError:[error]' property to user 
    //     state.all.items = state.items.map(user => {
    //         if (user.id === id) {
    //             // make copy of user without 'deleting:true' property
    //             const { deleting, ...userCopy } = user;
    //             // return copy of user with 'deleteError:[error]' property
    //             return { ...userCopy, deleteError: error }
    //         }

    //         return user;
    //     })
    // }
}

export const creator = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}